import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { setNoFocus } from '../../helpers/events-focus';
const InfoButton = styled.div``;
const InfoButtonComponent = /*#__PURE__*/React.forwardRef(({
  as,
  forwardedAs,
  noFocus,
  hasTouch,
  inactive,
  clickable,
  ...props
}, forwardedRef) => {
  const {
    href,
    onClick
  } = props;
  const buttonAs = useMemo(() => {
    let componentAs = forwardedAs ?? as;
    if (!componentAs && href && !inactive) {
      componentAs = 'a';
    } else if (!componentAs && (onClick || clickable) && !inactive) {
      componentAs = 'button';
    } else if (!componentAs) {
      componentAs = 'div';
    }
    return componentAs;
  }, [forwardedAs, as, href, onClick, inactive, clickable]);
  return /*#__PURE__*/React.createElement(InfoButton, _extends({
    as: buttonAs,
    ref: forwardedRef
  }, props, setNoFocus(props, noFocus)));
});
export default InfoButtonComponent;